@if (anyRows()) {
    <ag-grid-angular
        class="ag-theme-alpine"
        [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        [enableCellTextSelection]="true"
        [statusBar]="statusBar"
        (firstDataRendered)="onFirstDataRendered($event)"
        (sortChanged)="onSortChanged($event)"
        (filterChanged)="onFilterChanged($event)"
        (gridReady)="onGridReady($event)"
    />
} @else {
    <div class="subtitle">{{ 'grid.noRows' | translate }}</div>
}
